import logo from '@assets/logo.svg';
import { Box } from '@components/ui/atoms/Box';
import { Container } from '@components/ui/atoms/Container';
import { Flex } from '@components/ui/atoms/Flex';
import { Image } from '@components/ui/atoms/Image';
import { Text } from '@components/ui/atoms/Text';
import { floatHover10 } from '@shared/utils/animationsUtil';
import React from 'react';
import { FaFacebookF, FaInstagram, FaLinkedin, FaTiktok } from 'react-icons/fa';

export const FooterSection: React.FC = () => {
    return (
        <Box w="full" bg="white" py="2rem">
            <Container maxW="container.xl">
                <Flex direction="column" align="center">
                    {/* Logo and Name */}
                    <Flex align="center" gap="0.5rem" mb="1.5rem" animation={`${floatHover10} 8s ease-in-out infinite`}>
                        <Image src={logo} w={10} h={10} alt="logo" />
                        <Text fontWeight="bold" fontSize="lg" color="gray.800">Bhutan Payments</Text>
                    </Flex>

                    {/* Subtitle */}
                    <Text color="gray.600" fontSize="sm" mb="2.5rem" textAlign="center">
                        Software as a service tailored specifically for the services and products industry in Bhutan
                    </Text>

                    {/* Social Icons */}
                    <Flex gap="1.5rem" mb="2.5rem">
                        <a aria-label="LinkedIn" href={"https://www.linkedin.com/company/bhutanpayments"} target="_blank" rel="external noopener noreferrer">
                            <Box color="gray.400" _hover={{ color: "blue.800" }} transition="color 0.2s">
                                <FaLinkedin size={20} />
                            </Box>
                        </a>
                        <a aria-label="Facebook" href={"https://www.facebook.com/bhutanpayments"} target="_blank" rel="external noopener noreferrer">
                            <Box color="gray.400" _hover={{ color: "blue.600" }} transition="color 0.2s">
                                <FaFacebookF size={20} />
                            </Box>
                        </a>
                        <a aria-label="Instagram" href={"https://www.instagram.com/bhutanpayments"} target="_blank" rel="external noopener noreferrer">
                            <Box color="gray.400" _hover={{ color: "pink.600" }} transition="color 0.2s">
                                <FaInstagram size={20} />
                            </Box>
                        </a>
                        <a aria-label="TikTok" href={"https://www.tiktok.com/@bhutanpayments"} target="_blank" rel="external noopener noreferrer">
                            <Box color="gray.400" _hover={{ color: "black" }} transition="color 0.2s">
                                <FaTiktok size={20} />
                            </Box>
                        </a>
                    </Flex>

                    {/* Links */}
                    <Flex gap={{ base: '2rem', md: '4rem' }} mb="2.5rem" direction={{ base: 'column', sm: 'row' }} align="center">
                        <a href="#"><Text fontSize="sm" color="gray.600" _hover={{ color: "purple.600" }} transition="color 0.2s">Home</Text></a>
                        <a href="#services"><Text fontSize="sm" color="gray.600" _hover={{ color: "purple.600" }} transition="color 0.2s">Services</Text></a>
                        <a href="#supported"><Text fontSize="sm" color="gray.600" _hover={{ color: "purple.600" }} transition="color 0.2s">Supported Users</Text></a>
                    </Flex>

                    {/* Disclaimer */}
                    <Text color="gray.500" fontSize="sm" textAlign="center" lineHeight="1.8" mb="3rem">
                        Beyul Labs (dba Bhutan Payments) is a financial technology company, not a bank.<br />
                        Banking services provided by Bhutan National Bank.
                    </Text>

                    {/* Bottom Section */}
                    <Box w="full" borderTop="1px solid" borderColor="gray.200" pt="2rem">
                        <Flex justify="center" align="center" direction={{ base: 'column', md: 'row' }} gap="1rem">
                            <Text color="gray.500" fontSize="sm">
                                Copyright © 2026 Beyul Labs. All Rights Reserved.
                            </Text>
                            {/* <a href="#">
                                <Text color="gray.500" fontSize="sm" _hover={{ color: "gray.800" }} transition="color 0.2s">
                                    Terms of Use
                                </Text>
                            </a> */}
                        </Flex>
                    </Box>
                </Flex>
            </Container>
        </Box>
    );
};

FooterSection.displayName = 'FooterSection';
